import type { ReactNode } from 'react';
import { DsProvider } from '@workpay/ds-shared/context/DsProvider';
import { getDirection } from '@workpay/ds-shared/utils/direction';
import { signingService } from '@services/signingService';
import { reviewService } from '@services/reviewService';
import { fileService } from '@services/fileService';
import { editorService } from '@services/editorService';
import { ONLYOFFICE_URL } from '@lib/runtimeConfig';
import { useTranslation } from '@hooks/useTranslation';
import { useLocalizationStore } from '@stores/localizationStore';

const services = {
  signing: signingService,
  reviewPublic: reviewService,
  file: fileService,
  editor: editorService,
};

export function DsExternalProvider({ children }: { children: ReactNode }) {
  const { t } = useTranslation();
  const language = useLocalizationStore((s) => s.language);
  const direction = getDirection(language);
  return (
    <DsProvider
      services={services}
      translate={t}
      direction={direction}
      // No notify — swallow notifications
      // No hasPermission — external = no permissions
      onlyOfficeUrl={ONLYOFFICE_URL}
    >
      {children}
    </DsProvider>
  );
}
